import type { CSSProperties } from "react";
import styles from "./BandsIntro.module.css";
import type { StageIntroVariantProps } from "./types";

/** Pattern C: full-width colored bands that sweep in one after another. */
export default function BandsIntro({ stageLabel, conditions }: StageIntroVariantProps) {
  return (
    <section className={styles.stack}>
      <p className={styles.stage}>{stageLabel}</p>
      {conditions.map((condition, index) => (
        <div key={condition.id} className={styles.band} style={{ "--power": condition.color, "--i": index } as CSSProperties}>
          <span className={styles.force}><b>{condition.label}</b>{condition.name}</span>
          <strong className={styles.word} lang="en">{condition.text}</strong>
          <span className={styles.gloss}>{condition.gloss}</span>
        </div>
      ))}
    </section>
  );
}
